import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'spell-check',
  size: 24,
  node: [
    ['path', { d: 'm20 15-5.5 5.5L12 18', key: '6ytzne' }],
    ['path', { d: 'm4 16 6-12 5.115 10.23', key: 'fyukjg' }],
    ['path', { d: 'M6 12h8', key: '1hdiqa' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name SpellCheck
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMjAgMTUtNS41IDUuNUwxMiAxOCIgLz4KICA8cGF0aCBkPSJtNCAxNiA2LTEyIDUuMTE1IDEwLjIzIiAvPgogIDxwYXRoIGQ9Ik02IDEyaDgiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/spell-check
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SpellCheck = createLucideIcon(__iconData);

export default SpellCheck;
